var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_393_61469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_393_61469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 9.18429V4.14178H8.25V9.18429H2.625ZM2.625 15.5715V10.529H8.25V15.5715H2.625ZM9.75 9.18429V4.14178H15.375V9.18429H9.75ZM9.75 15.5715V10.529H15.375V15.5715H9.75ZM3.75 8.17579H7.125V5.15029H3.75V8.17579ZM10.875 8.17579H14.25V5.15029H10.875V8.17579ZM10.875 14.563H14.25V11.5375H10.875V14.563ZM3.75 14.563H7.125V11.5375H3.75V14.563Z",
    fill: "#171A1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b4b40071e49b7fde7851dfa520b3293d.svg";
export { ForwardRef as ReactComponent };